module.exports = "<div layout=\"column\"><img ng-src=\"{{vm.profilePicture}}\" ng-style=\"vm.style\"></div>\n";